import { lazy, Suspense } from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { SSOProvider } from './SSOProvider';
import SSOCallback from '../components/pages/SSOCallback';
import { PAGE_ROUTES } from '../constants/common';
import MarketingApplication from '../components/pages/MarketingApplication';
import PageLoader from '../components/molecules/PageLoader';

const KnowledgeCenterPage = lazy(
  () => import('../components/widgets/KnowledgeCenter')
);

export const router = createBrowserRouter([
  {
    path: PAGE_ROUTES.DEFAULT,
    element: <Navigate to={PAGE_ROUTES.HOME} replace />,
  },
  {
    path: PAGE_ROUTES.HOME,
    element: (
      <Suspense fallback={<PageLoader />}>
        <SSOProvider>
          <MarketingApplication isLoadHomeWidget key='home' />
        </SSOProvider>
      </Suspense>
    ),
  },
  {
    path: PAGE_ROUTES.AUTOMATION,
    element: (
      <Suspense fallback={<PageLoader />}>
        <div>GenAI Automation</div>
      </Suspense>
    ),
  },
  {
    path: PAGE_ROUTES.GENERATE_CONTENT,
    element: (
      <Suspense fallback={<PageLoader />}>
        <SSOProvider>
          <MarketingApplication isLoadMarketingWidget key='create-content' />
        </SSOProvider>
      </Suspense>
    ),
    children: [
      {
        path: PAGE_ROUTES.KNOWLEDGE_CENTER,
        element: <KnowledgeCenterPage />,
      },
    ],
  },
  {
    path: PAGE_ROUTES.ACCESS_MANAGEMENT,
    element: (
      <Suspense fallback={<PageLoader />}>
        <SSOProvider>
          <MarketingApplication isLoadAccessWidget key='access-management' />
        </SSOProvider>
      </Suspense>
    ),
  },
  {
    path: PAGE_ROUTES.UPLOAD_GENERATE,
    element: (
      <Suspense fallback={<PageLoader />}>
        <SSOProvider>
          <MarketingApplication isLoadUploadView key='upload-and-create' />
        </SSOProvider>
      </Suspense>
    ),
  },
  {
    path: PAGE_ROUTES.KNOWLEDGE_CENTER,
    element: (
      <Suspense fallback={<PageLoader />}>
        <SSOProvider>
          <MarketingApplication key='knowledge-center' />
        </SSOProvider>
      </Suspense>
    ),
  },
  {
    path: PAGE_ROUTES.CALLBACK,
    element: <SSOCallback />,
  },
  {
    path: PAGE_ROUTES.ANY,
    element: <Navigate to='/' replace />,
  },
]);
